function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M301.084 269.409c59.208 14.35 109.964 14.597 113.368.552 3.404-14.045-41.834-37.064-101.041-51.413l-12.327 50.86",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M301.084 269.409c59.208 14.35 109.964 14.597 113.368.552 3.404-14.045-41.834-37.064-101.041-51.413l-12.327 50.86",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("path", {
  d: "M253.233 269.5c-59.014 15.127-109.763 16.04-113.352 2.042-3.588-14 41.344-37.61 100.358-52.736l12.994 50.695",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M253.233 269.5c-59.014 15.127-109.763 16.04-113.352 2.042-3.588-14 41.344-37.61 100.358-52.736l12.994 50.695",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("path", {
  d: "M210.044 427.195c0-18.123 29.75-32.815 66.45-32.815 36.698 0 66.449 14.692 66.449 32.815H210.044",
  fill: "#797979"
}), /*#__PURE__*/React.createElement("path", {
  d: "M210.044 427.195c0-18.123 29.75-32.815 66.45-32.815 36.698 0 66.449 14.692 66.449 32.815H210.044",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 276.649,
  cy: 313.768,
  rx: 78.756,
  ry: 101.351,
  fill: "#000"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 276.649,
  cy: 313.768,
  rx: 78.756,
  ry: 101.351,
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 276.648,
  cy: 209.024,
  rx: 55.375,
  ry: 36.331,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 276.648,
  cy: 209.024,
  rx: 55.375,
  ry: 36.331,
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("circle", {
  cx: 276.647,
  cy: 311.57,
  r: 74.579,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 276.647,
  cy: 311.57,
  r: 74.579,
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 276.649,
  cy: 224.143,
  rx: 44.3,
  ry: 22.268,
  fill: "#797979"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 276.649,
  cy: 224.143,
  rx: 44.3,
  ry: 22.268,
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M276.496 414.007h.308v11.72h-.308z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7,
  d: "M276.496 414.007h.308v11.72h-.308z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
  cx: 246.612,
  cy: 200.654,
  rx: 6.139,
  ry: 5.86,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 246.612,
  cy: 200.654,
  rx: 6.139,
  ry: 5.86,
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
  cx: 307.123,
  cy: 200.654,
  rx: 6.139,
  ry: 5.86,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 307.123,
  cy: 200.654,
  rx: 6.139,
  ry: 5.86,
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M169.171 182.097c.796 18.427 35.603-.982 35.603-.982s-36.4-17.444-35.603.982z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169.171 182.097c.796 18.427 35.603-.982 35.603-.982s-36.4-17.444-35.603.982z",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M206.805 128.917c-15.205 10.44 19.7 29.673 19.7 29.673s-4.496-40.113-19.7-29.673z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M206.805 128.917c-15.205 10.44 19.7 29.673 19.7 29.673s-4.496-40.113-19.7-29.673z",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7,
  d: "M234.437 224.803h84.419"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7,
  d: "M172.649 427.195H380.34"
})));

var SvgPenguin = function SvgPenguin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "136.181 123.683 281.952 308.012"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,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";
export { SvgPenguin as ReactComponent };